import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { services } from "../../data/services";
import { IconArrow } from "../Icon";
import { Reveal } from "../motion/Reveal";
import { Stagger, StaggerItem } from "../motion/Stagger";

export function ServicesGrid({ compact = false }: { compact?: boolean }) {
  const items = compact ? services.slice(0, 6) : services;
  return (
    <section id="services" className="section bg-white">
      <div className="container-page">
        <Reveal as="header" className="max-w-2xl">
          <span className="eyebrow">Nos prestations</span>
          <h2 className="mt-4">Des services d'entretien adaptés à chaque besoin à Vichy</h2>
          <p className="mt-4 text-ink-muted text-lg">
            De l'entretien quotidien de vos bureaux au nettoyage fin de chantier, nous couvrons
            toute la chaîne de propreté professionnelle dans l'Allier.
          </p>
        </Reveal>

        <Stagger className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((s) => (
            <StaggerItem key={s.id} as="article">
              <motion.article
                id={s.id}
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="card group relative flex flex-col h-full overflow-hidden hover:border-brand-200 hover:shadow-soft-lg transition-colors duration-300"
              >
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  aria-hidden="true"
                  style={{
                    background:
                      "radial-gradient(500px circle at var(--mx,50%) var(--my,0%), rgba(34,211,238,0.10), transparent 40%)",
                  }}
                />
                <motion.div
                  className="grid h-12 w-12 place-items-center rounded-xl bg-brand-50 text-brand-700 group-hover:bg-brand-700 group-hover:text-white transition-colors"
                  whileHover={{ rotate: [0, -6, 6, 0] }}
                  transition={{ duration: 0.5 }}
                >
                  <s.icon className="h-6 w-6" />
                </motion.div>
                <h3 className="mt-5">{s.title}</h3>
                <p className="mt-2 text-ink-muted text-sm leading-relaxed">{s.short}</p>
                <ul className="mt-4 space-y-1.5 text-sm">
                  {s.bullets.slice(0, 3).map((b) => (
                    <li key={b} className="flex gap-2 text-ink">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-accent-500 flex-none" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={s.pageHref ?? `/services#${s.id}`}
                  className="mt-auto pt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-700 hover:text-brand-900 group/link"
                >
                  {s.pageHref ? "Voir la page dédiée" : "En savoir plus"}
                  <IconArrow className="h-4 w-4 transition-transform group-hover/link:translate-x-1" />
                </Link>
              </motion.article>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
